import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import '@adornis/chemistry/elements/components/x-card.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import { type Renderable } from '@adornis/chemistry/renderable.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @element bh-stat-card
 */
@customElement('bh-stat-card')
export class BHStatCard extends BuchungsheldLitElement {
  @property({ type: Boolean }) advanced = false;

  @property({ attribute: false }) value: Renderable = '';
  @property() name = '';

  override render() {
    if (this.advanced)
      return html`
        <x-basic-card>
          <x-flex padding="lg" space="md" space-between> <x-text> ${this.name} </x-text> ${this.value} </x-flex>
        </x-basic-card>
      `;
    return html`
      <x-basic-card>
        <x-flex horizontal crossaxis-center padding="lg" space="md" space-between>
          <x-text> ${this.name} </x-text> <x-text bold> ${this.value} </x-text>
        </x-flex>
      </x-basic-card>
    `;
  }
}
